import { AlertCircle } from 'lucide-react'
import { Modal } from '@shared/ui/Modal'
import { useTelegramAuthPolling } from '../model/useTelegramAuthPolling'
import styles from './TelegramAuthWaitModal.module.css'

interface TelegramAuthWaitModalProps {
  /** Токен авторизации (telegram_auth_...) */
  token: string
  /** Колбэк: бэк подтвердил (status=confirmed) */
  onConfirmed: () => void
  /** Колбэк: токен истёк/использован (404) */
  onExpired: () => void
  /** Колбэк отмены (клик по «Отмена» или по overlay) */
  onCancel: () => void
}

/**
 * Модалка ожидания подтверждения web-авторизации из Telegram.
 * Поллит check-token и вызывает onConfirmed/onExpired/onCancel.
 */
export const TelegramAuthWaitModal = ({
  token,
  onConfirmed,
  onExpired,
  onCancel
}: TelegramAuthWaitModalProps) => {
  useTelegramAuthPolling(token, true, onConfirmed, onExpired)

  return (
    <Modal onClose={onCancel}>
      <div className={styles.panel}>
        <div className={styles.header}>
          <AlertCircle className={styles.icon} strokeWidth={1.5} aria-hidden="true" />
          <div className={styles.headings}>
            <h3 className={styles.title}>Ждём подтверждения в Telegram</h3>
            <p className={styles.text}>
              Откройте бот и нажмите «Подтвердить». Это окно обновится автоматически.
            </p>
          </div>
        </div>
        <button type="button" onClick={onCancel} className={styles.closeLink}>
          Отмена
        </button>
      </div>
    </Modal>
  )
}
